export function SectionCard({ title, eyebrow, className = "", children }) {
  return (
    <section className={`goldbot-card ${className}`}>
      <div className="goldbot-card__heading">
        {eyebrow && <span className="goldbot-card__eyebrow">{eyebrow}</span>}
        <h2>{title}</h2>
      </div>
      {children}
    </section>
  );
}

export function MetricGrid({ items, className = "" }) {
  return (
    <div className={`goldbot-metric-grid ${className}`}>
      {items.map((item) => (
        <div className="goldbot-metric" key={item.label}>
          <span className="goldbot-metric__label">{item.label}</span>
          <strong className={item.tone ? `is-${item.tone}` : ""}>
            {item.value}
          </strong>
          {item.detail && (
            <span className="goldbot-metric__detail">{item.detail}</span>
          )}
        </div>
      ))}
    </div>
  );
}

export function StatusList({ items }) {
  return (
    <div className="goldbot-status-list">
      {items.map((item) => (
        <div className="goldbot-status" key={item.label}>
          <div>
            <span className={`goldbot-status__dot is-${item.tone}`} />
            <span>{item.label}</span>
          </div>
          {item.status ? (
            <StatusBadge label={item.value} tone={item.status} />
          ) : (
            <strong>{item.value}</strong>
          )}
        </div>
      ))}
    </div>
  );
}

export function StatusBadge({ label, tone = "online" }) {
  const icons = {
    online: "🟢",
    offline: "🔴",
    connecting: "🟡",
  };

  return (
    <span className={`goldbot-badge is-${tone}`}>
      <span aria-hidden="true">{icons[tone]}</span>
      {label}
    </span>
  );
}

export function PageIntro({ eyebrow, title, description }) {
  return (
    <header className="goldbot-page-intro">
      <span className="goldbot-card__eyebrow">{eyebrow}</span>
      <h1>{title}</h1>
      <p>{description}</p>
    </header>
  );
}
